import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Config mancante o palesemente invalida = errore ESPLICITO. Mai un client
// mock o placeholder: un deploy senza env deve fallire in modo visibile,
// non simulare login/dati fantasma.
const configError = (() => {
  if (!supabaseUrl || !supabaseAnonKey) {
    return 'Variabili REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY mancanti al build.';
  }
  try {
    const { protocol } = new URL(supabaseUrl);
    if (protocol !== 'https:') return `REACT_APP_SUPABASE_URL non è un URL https valido: ${supabaseUrl}`;
  } catch {
    return `REACT_APP_SUPABASE_URL non è un URL valido: ${supabaseUrl}`;
  }
  return null;
})();

if (configError) {
  const message = `Uptra: configurazione Supabase non valida. ${configError}`;
  // Schermata di errore leggibile al posto dell'app (l'utente/dev capisce
  // subito), più throw per fermare qualsiasi codice a valle.
  // eslint-disable-next-line no-console
  console.error(message);
  if (typeof document !== 'undefined' && document.body) {
    document.body.innerHTML =
      '<div style="font-family:system-ui;padding:2rem;max-width:36rem;margin:0 auto">' +
      '<h1 style="color:#b91c1c">Errore di configurazione</h1>' +
      '<p>L\'app non può avviarsi: configurazione del backend mancante o non valida.</p>' +
      '<p style="color:#6b7280;font-size:0.9rem">Dettaglio per chi fa il deploy: ' +
      configError + '</p></div>';
  }
  throw new Error(message);
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
